import { isSelfRegistrationEnabled } from '@/utils/whatsapp';

const mspiRoutes = [

    {
        path: '/mspi-evaluation',
        name: 'MSPIEvaluationComponent',
        component: () => import('../views/mspi/MSPIEvaluationComponent.vue'),
        meta: {
            requiresAuth: true,
            planModule: 'compliance',
        }

    },

    {
        path: '/mspi',
        name: 'IndexMSPI',
        component: () => import('../views/mspi/IndexMSPI.vue'),

    },

    {
        path: '/mspi-otp',
        name: 'OTPVerification',
        component: () => import('../views/mspi/OTPVerification.vue'),
        beforeEnter: () => (isSelfRegistrationEnabled() ? true : { name: 'IndexMSPI' }),

    },
    {
        path: '/mspi-create-tenant',
        name: 'MSPITenantCreation',
        component: () => import('../views/mspi/MSPITenantCreation.vue'),
        meta: {
            requiresAuth: true,
        },
        beforeEnter: () => (isSelfRegistrationEnabled() ? true : { name: 'IndexMSPI' }),

    },
];

export default mspiRoutes;